/**
 * Soldera company ID used for external buyer invoices
 * This is the company record for Soldera OÜ in the database
 */
export const SOLDERA_COMPANY_ID = 500;

export const SOLDERA_COMPANY_NAME = "Soldera OÜ";
